import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  AtsInactiveWarning,
  useAtsInactiveWarning,
} from 'modules/app_store/components/CTAButton/AtsInactiveWarning'
import IntegrationModal from 'modules/app_store/components/IntegrationModal'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  subscriptionAddon: SubscriptionAddon
}

const IntegrationButton = ({ subscriptionAddon }: Props) => {
  const [upgradePlanModal, setUpgradePlanModal] = React.useState(false)
  const [integrationModal, setIntegrationModal] = React.useState(false)

  const id = subscriptionAddon.id
  const inactiveWarning = useAtsInactiveWarning(id)
  if (inactiveWarning) return <AtsInactiveWarning />

  const handleClick = () => {
    if (subscriptionAddon.attributes.available_for_current_plan) {
      setIntegrationModal(true)
    } else {
      setUpgradePlanModal(true)
    }
  }

  return (
    <Box flexDirection="row" alignItems="center" gap="s8" paddingY="s16">
      <Button onClick={handleClick}>{i18n.t('app_store_v2.common.cta_button.integration')}</Button>
      <Text size="100" color="grey800" weight="medium">
        {i18n.t('app_store_v2.common.cta_info.integration')}
      </Text>
      {upgradePlanModal && (
        <RequestUpgradeModal
          requestReason={ValidReasons.UpgradeFromLegacy}
          requestSource="marketplace-legacy-apps"
          onClose={() => setUpgradePlanModal(false)}
        />
      )}
      {integrationModal && <IntegrationModal id={id} onClose={() => setIntegrationModal(false)} />}
    </Box>
  )
}

export default IntegrationButton
